import { render, staticRenderFns } from "./acpm-matriz-editar.vue?vue&type=template&id=6973d870&"
import script from "./acpm-matriz-editar.vue?vue&type=script&lang=js&"
export * from "./acpm-matriz-editar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports